import React from 'react';
import { ModuleBridge } from '../components';

export const EditProfile = () => {
    return <ModuleBridge moduleId="edit_profile_module" />;
};
